export const RECENT_PLACES_KEY = "petroprize:recent-places:v1";
export const MAX_RECENT_PLACES = 5;

function validPlace(place) {
  return place
    && typeof place.label === "string"
    && place.label.trim()
    && Number.isFinite(place.lat)
    && Number.isFinite(place.lng);
}

export function normalizeRecentPlaces(value) {
  if (!Array.isArray(value)) return [];
  return value
    .filter(validPlace)
    .slice(0, MAX_RECENT_PLACES)
    .map((place) => ({
      label: place.label.trim(),
      query: typeof place.query === "string" ? place.query.trim() : place.label.trim(),
      lat: Number(place.lat),
      lng: Number(place.lng),
    }));
}

export function addRecentPlace(current, place) {
  if (!validPlace(place)) return normalizeRecentPlaces(current);
  const normalized = {
    label: place.label.trim(),
    query: typeof place.query === "string" && place.query.trim() ? place.query.trim() : place.label.trim(),
    lat: Number(place.lat),
    lng: Number(place.lng),
  };
  const withoutDuplicate = normalizeRecentPlaces(current).filter((saved) => {
    const sameCoordinates = Math.abs(saved.lat - normalized.lat) < 0.0005 && Math.abs(saved.lng - normalized.lng) < 0.0005;
    return !sameCoordinates && saved.label.toLocaleLowerCase("es") !== normalized.label.toLocaleLowerCase("es");
  });
  return [normalized, ...withoutDuplicate].slice(0, MAX_RECENT_PLACES);
}
